module.exports = __webpack_public_path__ + "static/media/member_benefits.282a13ae.png";